import React from "react";
import { Box, styled, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { ReactNode } from "react";

const StyledBox = styled("div")(({ theme }) => ({
  padding: theme.spacing(2),
  borderRadius: "5px",
  boxShadow: "0px 0px 5px 0px rgba(0, 0, 0, 0.25)",
  backgroundColor: "#fff",
  maxWidth: "240px",
  minWidth: "20%",
  textAlign: "center",
  cursor: "pointer",
  height: "120px",
  transition: "transform 0.2s",
  position: "relative",
  "& .MuiSwitch-root ": {
    position: "absolute",
    top: "5%",
    right: "5%",

    "& .MuiSwitch-thumb ": {
      border: "1px solid #ccc",
    },
  },
  "&:hover": {
    backgroundColor: "#f4f9f8",
    "& .MuiCheckbox-root": {
      color: "#ffffff",
    },
  },
}));

interface SharedCardProps {
  icon?: React.ReactElement | string;
  number?: number;
  title: string;
  customStyles?: object;
  link?: string;
  onClick?: () => void;
  action?: ReactNode;
}

const SharedCard: React.FC<SharedCardProps> = ({
  icon,
  number,
  title,
  link,
  onClick,
  action,
}) => {
  const navigate = useNavigate();

  const handleClick = () => {
    if (link) {
      navigate(link);
    } else if (onClick) {
      onClick();
    }
  };

  return (
    <StyledBox onClick={handleClick}>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: "100%",
        }}
      >
        {typeof icon === "string" ? (
          <img
            src={icon}
            alt="icon"
            style={{ width: 55, height: 55, objectFit: "contain" }}
          />
        ) : React.isValidElement(icon) ? (
          React.cloneElement(icon, {})
        ) : (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              height: 55,
              width: 55,
            }}
          >
            <Typography variant="caption">No Icon</Typography>
          </div>
        )}
      </Box>

      {number !== undefined && (
        <Typography variant="h6" sx={{ fontWeight: 500 }}>
          {number}
        </Typography>
      )}

      <Typography
        variant="body2"
        sx={{ marginTop: 1, fontWeight: 500, color: "#0C7E68" }}
      >
        {title}
      </Typography>
      {action && <Box sx={{ mt: 2 }}>{action}</Box>}
    </StyledBox>
  );
};

export default SharedCard;
